import React from 'react';
import uuidv4 from 'uuid/v4';

import AirQualityParameters from './AirQualityParameters';

const getLevel = (value, param) => {
  let newValue = parseFloat(value);
  if(param === "PM2_5"){
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 30))
      return '1';
    if((newValue >= 31)&&(newValue <= 60))
      return '2';
    if((newValue >= 61)&&(newValue <= 90))
      return '3';
    if((newValue >= 91)&&(newValue <= 120))
      return '4';
    if((newValue >= 121)&&(newValue <= 250))
      return '5';
    if(newValue >= 251)
      return '6';
  }
  if(param === "PM10"){
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 50))
      return '1';
    if((newValue >= 51)&&(newValue <= 100))
      return '2';
    if((newValue >= 101)&&(newValue <= 250))
      return '3';
    if((newValue >= 251)&&(newValue <= 350))
      return '4';
    if((newValue >= 351)&&(newValue <= 430))
      return '5';
    if(newValue >= 431)
      return '6';
  }
  if(param === "NO2"){
    newValue = newValue/1.88;
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 40))
      return '1';
    if((newValue >= 41)&&(newValue <= 80))
      return '2';
    if((newValue >= 81)&&(newValue <= 180))
      return '3';
    if((newValue >= 181)&&(newValue <= 280))
      return '4';
    if((newValue >= 281)&&(newValue <= 400))
      return '5';
    if(newValue >= 401)
      return '6';
  }
  if(param === "O3"){
    newValue = newValue/1.96;
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 50))
      return '1';
    if((newValue > 50)&&(newValue <= 100))
      return '2';
    if((newValue > 100)&&(newValue <= 168))
      return '3';
    if((newValue > 168)&&(newValue <= 208))
      return '4';
    if((newValue > 208)&&(newValue <= 748))
      return '5';
    if(newValue > 748)
      return '6';
  }
  if(param === "CO"){
    newValue = (newValue/1000)/1.15;
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 1))
      return '1';
    if((newValue > 1)&&(newValue <= 2.0))
      return '2';
    if((newValue > 2)&&(newValue <= 10))
      return '3';
    if((newValue > 10)&&(newValue <= 17))
      return '4';
    if((newValue > 17)&&(newValue <= 34))
      return '5';
    if(newValue > 34)
      return '6';
  }
  if(param === "SO2"){
    newValue = newValue/2.62;
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 40))
      return '1';
    if((newValue > 40)&&(newValue <= 80))
      return '2';
    if((newValue > 81)&&(newValue <= 180))
      return '3';
    if((newValue > 180)&&(newValue <= 280))
      return '4';
    if((newValue > 280)&&(newValue <= 400))
      return '5';
    if(newValue > 400)
      return '6';
  }
  if(param === "NH3"){
    // newValue = (newValue/1000)/1.15;
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 200))
      return '1';
    if((newValue > 200)&&(newValue <= 400))
      return '2';
    if((newValue > 400)&&(newValue <= 800))
      return '3';
    if((newValue > 800)&&(newValue <= 1200))
      return '4';
    if((newValue > 1200)&&(newValue <= 1800))
      return '5';
    if(newValue > 1800)
      return '6';
  }
  if(param === "PB"){
    // newValue = (newValue/1000)/1.15;
    if(newValue === 0)
      return '0';
    if((newValue > 0)&&(newValue <= 0.5))
      return '1';
    if((newValue > 0.5)&&(newValue <= 1.0))
      return '2';
    if((newValue > 1.0)&&(newValue <= 2.0))
      return '3';
    if((newValue > 2.0)&&(newValue <= 3.0))
      return '4';
    if((newValue > 3.0)&&(newValue <= 3.5))
      return '5';
    if(newValue > 3.5)
      return '6';
  }
  return '0';
};

const getMarker = (source, value, param) => {
  if(source === "ThingSpeak")
    return <small>
      <i style={{
            position: 'relative',
            left: '0px'
          }} className={("fa fa-map-pin aqi-level-" + getLevel(value, param))} aria-hidden="true" />
      </small>;
  if(source === "OpenAQ")
    return <small>
      <i className={("fa fa-map-marker aqi-level-" + getLevel(value, param))} aria-hidden="true" />
    </small>;
  // if(source === "")
  //   return <i className="fa fa-map-marker" aria-hidden="true" />;
  return <small>
    <i className={"fa fa-map-marker aqi-level-" + getLevel(value, param)} aria-hidden="true" />
  </small>;
};

class AirQualityDataItem {
  constructor(initializer = {}) {
    Object.assign(this, initializer);
    if(this.uid === undefined) {
      this.uid = uuidv4();
    }
  }
  isValid() {
    return true;
  }
  getColourCodedMarkers(param = 'PM2_5') {
    let tbody = Object.entries(AirQualityDataItem.PARAMETERS).map(([key, value]) => {
      return [key, this["MEASUREMENTS"][key]];
    }).filter(([key, value]) => ((value !== undefined)&&(value !== 0))).reduce((previousRows, param) => {
      return(previousRows +
        '<tr><td class="text-left">' +
        AirQualityDataItem.PARAMETERS[param[0]].markup +
        '</td><td class="text-right">' +
        param[1] + ' ' + AirQualityDataItem.PARAMETERS[param[0]].unit +
        '</td></tr>');
    }, '');
    let table = (tbody.length > 0)? '<table class="table"><tbody>' +
                                      tbody +
                                      '</tbody></table>':
                                    '<div>No data available</div>';
    let markerObj = {
      key: this.uid,
      position: this.LOCATION,
      className: "h1",
      components: [
        <div className={"text-shadow aqi-level-" + getLevel(this["MEASUREMENTS"][param], param)}
          key={Math.random()}>
          {
            getMarker(this.SOURCE, this["MEASUREMENTS"][param], param)
          }
        </div>,
        ((this["MEASUREMENTS"][param] !== undefined)&&((this["MEASUREMENTS"][param] !== 0)))?
          <div style={{
              height: '30px',
              width: '85px',
              position: 'relative',
              left: '-30px'
            }} className="card h6 well well-sm overlay-container-value overlay-container-background align-middle text-white text-nowrap text-center"
              dangerouslySetInnerHTML={{
                __html: '<small>' + this["MEASUREMENTS"][param] + '&nbsp;' + AirQualityDataItem.PARAMETERS[param].unit + '</small>'
              }} key={Math.random()} />:
          <div className="card h6 well well-sm overlay-container-value overlay-container-background text-white text-nowrap text-center"
                style={{
                  height: '22px',
                  width: '85px',
                  fontSize: '10px',
                  color: 'black',
                  position: 'relative',
                  left: '-23px'
                }} key={Math.random()}>
            Different Data
          </div>
      ],
      popup: {
        className: "popup-container",
        components: [
          <div className="d-block center-block text-center" key={Math.random()}>
            <b>{this.CHANNEL_NAME}</b>
          </div>,
          <br key={Math.random()}/>,
          <div className="d-block center-block text-center" key={Math.random()}>
            <div className="text-center table-responsive" key={Math.random()}
                  dangerouslySetInnerHTML={{__html: table}}></div>
          </div>,
          <div className="text-center" key={Math.random()}>
            Sensed on {
              (this.SENSED_AT).toLocaleDateString('en-GB')
            } at {
              (this.SENSED_AT).toLocaleTimeString('en-GB', { hour12: true })
            }
          </div>
        ]
      }
    };
    return markerObj;
  }
  static get PARAMETERS() {
    return AirQualityParameters;
  }
}

export default AirQualityDataItem;



// WEBPACK FOOTER //
// ./src/models/data/airQuality/AirQualityDataItem.js